import React, { PropsWithChildren } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { apiClientHooks } from "./InitApiClient";
import useMaintenanceModeState from "../hooks/useMaintenanceModeState";
import MaintenanceModal from "../components/MaintenanceModal";
import { AxiosError } from "axios";

const oneHourInMillis = 60 * 60 * 1000

const InitBackendAPI: React.FC<PropsWithChildren> = ({ children }) => {
  const maintenanceModeState = useMaintenanceModeState()

  const getSystemInfo = apiClientHooks.useGetSystemInfo({}, {
    staleTime: oneHourInMillis,
  })

  if (getSystemInfo.isError) {
    if (getSystemInfo.error instanceof AxiosError && getSystemInfo.error.response?.status === 503) {
      return <MaintenanceModal open={maintenanceModeState} />
    } else {
      console.error('[InitBackendAPI] Error fetching system info:', getSystemInfo.error)
      return <MaintenanceModal open={true} />
    }
  }
  
  if (getSystemInfo.isLoading) return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="50vh"
    >
      <Typography variant="h6" sx={{ mb: 2 }} gutterBottom>
        Starting up. Please wait.
      </Typography>
      <CircularProgress />
    </Box>
  );

  return <>{children}</>
}

export default InitBackendAPI